import { render, staticRenderFns } from "./BlogCategoryModal.vue?vue&type=template&id=28ba1928"
import script from "./BlogCategoryModal.vue?vue&type=script&lang=js"
export * from "./BlogCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports